/**
 * Formatuje datę do polskiego formatu
 * @param dateString - data w formacie string lub obiekt Date
 * @returns sformatowana data (np. "13 Maja, 2023")
 */
export const formatDate = (dateString: string | Date): string => {
  if (!dateString) return ''
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return ''

  const day = date.getDate()

  const monthNames = [
    'Stycznia', 'Lutego', 'Marca', 'Kwietnia', 'Maja', 'Czerwca',
    'Lipca', 'Sierpnia', 'Września', 'Października', 'Listopada', 'Grudnia'
  ]
  const month = monthNames[date.getMonth()]

  const year = date.getFullYear()

  return `${day} ${month}, ${year}`
}

/**
 * Formatuje datę do formatu ISO (YYYY-MM-DD)
 * @param date - data w formacie obiektu Date
 * @returns sformatowana data w formacie YYYY-MM-DD
 */
export const formatDateToISO = (date: Date): string => {
  return date.toISOString().split('T')[0]
}
